import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useSingleSaleHeaderStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            [theme.breakpoints.up('md')]: {
                borderBottom: '1px solid #d4d4d4'
            }
        },
        container: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%'
        },
        containerSearch: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        },
        boxSearch: {
            paddingTop: 20,
            paddingBottom: 24,

            [theme.breakpoints.up('md')]: {
                paddingTop: 24,
                paddingBottom: 20
            }
        },
        dateSelector: {
            position: 'relative',
            marginTop: 24,
            maxWidth: 320,

            [theme.breakpoints.down('sm')]: {
                maxWidth: '100%'
            }
        },
        datePickerDropdown: {
            zIndex: 10
        },
        errorBorder: {
            '& fieldset': {
                'borderColor': '#EF4F57 !important',
                '&:hover': {
                    borderColor: '#EF4F57 !important'
                }
            }
        },
        confirmationTitle: {
            margin: 0,
            fontFamily: 'Poppins, sans-serif',
            fontSize: 22,
            fontWeight: 600,
            lineHeight: '30px',
            textAlign: 'center'
        },
        confirmationQuestion: {
            margin: '16px 0 0',
            maxWidth: 340,
            fontFamily: 'Poppins, sans-serif',
            fontSize: 15,
            fontWeight: 400,
            lineHeight: '22px',
            textAlign: 'center'
        },
        confirmationFooter: {
            display: 'flex',
            width: '100%',
            gap: 16,

            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column'
            }
        }
    })
);
